import React from 'react'

import PropTypes from 'prop-types'

import { TextField, IconButton, TableCell, TableRow } from '@material-ui/core'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import styles from './Onboarding.module.css'

class MembersForm extends React.Component {

    render() {
        

        const deleteButton = `delete_item${this.props.idx}`
        return (
            <>
                <TableRow key={`member-${this.props.idx}`}>
                    <TableCell className={styles.cell}>
                        <TextField
                            required
                            autoComplete="off"
                            className={styles.textfield}
                            variant="outlined"
                            size="small"
                            name="username"
                            fullWidth={true}
                            onChange={(event) => this.props.handleChange(event, this.props.idx)}
                            value={this.props.members[this.props.idx].username}
                        />
                    </TableCell>
                    <TableCell className={styles.cell}>
                        <TextField
                            required
                            autoComplete="off"
                            className={styles.textfield}
                            variant="outlined"
                            size="small"
                            name="email"
                            fullWidth={true}
                            onChange={(event) => this.props.handleChange(event, this.props.idx)}
                            value={this.props.members[this.props.idx].email}
                        />
                    </TableCell>
                    <TableCell className={styles.cell}>
                        <TextField
                            required
                            autoComplete="off"
                            className={styles.textfield}
                            variant="outlined"
                            size="small"
                            name="first_name"
                            fullWidth={true}
                            onChange={(event) => this.props.handleChange(event, this.props.idx)}
                            value={this.props.members[this.props.idx].first_name}
                        />
                    </TableCell>
                    <TableCell className={styles.cell}>
                        <TextField
                            required
                            autoComplete="off"
                            className={styles.textfield}
                            variant="outlined"
                            size="small"
                            name="middle_name"
                            fullWidth={true}
                            onChange={(event) => this.props.handleChange(event, this.props.idx)}
                            value={this.props.members[this.props.idx].middle_name}
                        />
                    </TableCell>
                    <TableCell className={styles.cell}>
                        <TextField
                            required
                            autoComplete="off"
                            className={styles.textfield}
                            variant="outlined"
                            size="small"
                            name="last_name"
                            fullWidth={true}
                            onChange={(event) => this.props.handleChange(event, this.props.idx)}
                            value={this.props.members[this.props.idx].last_name}
                        />
                    </TableCell>
                    <TableCell className={styles.cell} align="right">
                        
                            <IconButton
                            color="secondary"
                            name={deleteButton}
                            onClick={() => this.props.removemember(this.props.idx)}>
                            <DeleteForeverIcon />
                            </IconButton>
                   
                    </TableCell>
                </TableRow>
                
            </>
        )
    }
}

export default MembersForm

MembersForm.propTypes = {
    idx: PropTypes.number,
    members: PropTypes.array,
    handleAutocomplete: PropTypes.func,
    handleChange: PropTypes.func,
    removemember: PropTypes.func,
    defaultLength: PropTypes.number

}
